import request from './request'

const SPDAPIURL = JSON.parse(localStorage.getItem('smturl'))


const pageMintenancePrototype = {
//  获取页面配置信息
  getPageConfig(data, u) {
    var url
    if (u) {
      url = SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/' + u[1] + '/SYSgetpageinfo'
    } else {
      url = '/GetPageInfo'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 获取同步的表的数据
  getSynchronousList(data) {
    return request({
      url: '/Account/ConfigDropDownList',
      method: 'post',
      data: data
    })
  },
  // 同步
  synchronous(data, u, f) {
    return request({
      url: '/Tsystemset/configAddBat/' + u + '/' + f,
      method: 'post',
      data: data
    })
  },
  // 添加
  add(data, u) {
    return request({
      url: SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/' + u[1] + '/add',
      method: 'post',
      data: data
    })
  },
  // 通过id获取信息
  getById(data, u) {
    var url
    if (u) {
      url = SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/SysPageConfigs/Getlist'
    } else {
      url = '/GetModeleByKey'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 通过id删除
  delById(data, u) {
    var url
    if (u) {
      url = SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/' + u[1] + '/Delete'
    } else {
      url = '/DeleteByKey'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 批量删除
  delByIdList(data, u) {
    return request({
      url: u,
      method: 'post',
      data: data
    })
  },
  // 修改
  update(data, u) {
    return request({
      url: SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/' + u[1] + '/edit',
      method: 'post',
      data
    })
  },
  // 获取所有
  getList(data, u) {
    var url
    if (u) {
      url = SPDAPIURL.CURRENTAPIUrl + u[0] + 'APP/' + u[1] + '/sysGetList'
    }
    return request({
      url: url,
      method: 'post',
      data: data
    })
  },
  // 获取弹窗配置
  getPopPageConfig(data) {
    return request({
      url: '/api/tsystemSet/GetPageInfo',
      method: 'post',
      data
    })
  },
  // 新增字段
  addFiled(data, u) {
    return request({
      url: SPDAPIURL.CURRENTAPIUrl + u[0] + 'app/SysPageConfigs/add',
      method: 'post',
      data: data
    })
  },
  // 修改字段
  updateFiled(data, u) {
    return request({
      url: SPDAPIURL.CURRENTAPIUrl + u[0] + 'app/SysPageConfigs/update',
      method: 'post',
      data: data
    })
  },
  //  删除批量字段
  delFiled(data, u) {
    return request({
      url: SPDAPIURL.CURRENTAPIUrl + u[0] + 'app/SysPageConfigs/delete',
      method: 'post',
      data: data
    })
  }
}

export default pageMintenancePrototype
